import { createAction, props } from '@ngrx/store';
import { ScheduleInfoBasicDto } from 'src/app/models/calendar/schedule/schedule-info-basic';
import { Task } from 'src/app/models/task/task';

export const taskList = createAction(
    '[Tasks] list'
);

export const tasksListSuccess =  createAction(
    '[Tasks] list success',
    props<{tasks: Task[]}>()
);

export const setTask = createAction(
    '[Set Task] set',
    props<{ editTask: Task | ScheduleInfoBasicDto}>()
);

export const setTaskSuccess = createAction(
    '[Set Task] set success',
    props<{ editTask: Task | ScheduleInfoBasicDto }>()
);
